module.exports = __webpack_public_path__ + "media/BS_Start_Desktop_Korr.2588adba.mp4";